<template>
    <div class="relative flex flex-col w-full font-sans bg-white rounded-lg ">
        <div>
            <div class="flex flex-col justify-between mb-6">
                <div class="flex flex-row">
                    <p class="text-sm md:text-xl font-bold text-brand-light">Шаг 2.&nbsp;</p>
                    <p class="text-sm md:text-xl font-bold text-main-text">Выбор заведения</p>
                </div>
                <div class="text-10px md:text-sm font-bold text-additional-text mt-2">Выберите заведение для будущей серии игр</div>
            </div>
        </div>

        <div class="flex flex-col " :key="key" v-for="(item, key) in changingGamesStore.dates">
            <div v-if="key != 0" class="flex flex-row justify-end">
                <div class="mt-6 w-2/3 mb-5"></div>
            </div>

            <div class="flex justify-start flex-col md:flex-row ">
              <div id="" class="flex flex-col relative">
                <div class="text-xs text-additional-text font-bold pb-2">Дата и время мероприятия</div>
                <div class="flex  flex-row items-end pb-4">
                  <div class="flex items-end flex-row">
                    <img style="fill: aqua" src="@/assets/SVG/calendar-light.svg" />
                    <div class=" text-main-text ml-3 md:text-base text-sm font-bold flex items-end outline-none"
                      v-text="formatDate(item.played_at, 'DD.MM.YYYY')"></div>
                  </div>
                  <div class="flex flex-row items-end pl-2 mr-10">
                    <img class="ml-5" src="@/assets/SVG/time-light.svg" />
                    <div class="text-main-text ml-3 font-bold text-sm md:text-base flex items-end outline-none">
                      {{formatDate(item.played_at, 'HH:mm')}}
                    </div>
                  </div>
                </div>
                <span v-if="changingGamesStore.errors.has(`dates.${key}.places`)" class="text-red text-xs absolute mt-12 pin-t"
                  v-text="changingGamesStore.errors.first(`dates.${key}.places`)"></span>
              </div>

              <div class="flex flex-col justify-between md:pl-24">
                <div class="text-xs text-additional-text font-bold pb-1">Заведение</div>
                <div :key="currIndex" v-for="(game, currIndex) in item.places" class="flex flex-col w-full">
                 <div class=" flex flex-row md:pr-12 justify-between md:justify-start items-center w-full pb-2 ">
                    <div class="flex flex-row items-start pl-6 relative">
                      <!--<selectbox class="font-bold text-main-text -ml-6 " :list-items="places" :is_place="true"-->
                        <!--v-model="item.places[currIndex]" placeholder="Выберите заведение"></selectbox>-->
                        <selectbox  v-if="isEdited && item.places[currIndex] && item.places[currIndex].uuid !== null"
                                    class="font-bold text-main-text -ml-6 " :list-items="places" :is_place="true"
                                    v-model="item.places[currIndex].place_id" placeholder="Выберите заведение"
                                    :disabled="hasTeams(key, currIndex)"
                                    :disabledErrorText="'Нельзя изменить, т. к. на это мероприятие уже зарегистрировались команды'"></selectbox>
                        <selectbox v-else class="font-bold text-main-text -ml-6 " :list-items="places" :is_place="true"
                                   v-model="item.places[currIndex]" placeholder="Выберите заведение"></selectbox>
                    </div>
                    <trash-bin v-show="!hasTeams(key, currIndex)" v-if="!isEdited || getPlacesCount(key) > 1" ref="trash" :delPlace="{dateIdx: key, placeIdx: currIndex}" @delete_element="onDeletePlace" class="trash-icon"></trash-bin>
                    <delete-modal key="delete_modal" v-if="delete_modal" @close="delete_modal = false"
                      @white_button="delete_modal = false" @yellow_button="delete_place" :partners="false"
                      :text="'Вы уверены, что хотите удалить заведение?'" :button_text_firs="'Отменить'"
                      :button_text_second="'Удалить'" class="z-50 flex flex-col"></delete-modal>
                  </div>
                  <span v-if="changingGamesStore.errors.has(`dates.${key}.places.${currIndex}`)"
                    class="text-red text-xs -mt-2"
                    v-text="changingGamesStore.errors.first(`dates.${key}.places.${currIndex}`)"></span>
                </div>
                <div @click="addPlace(key)" class="flex flex-row items-center cursor-pointer">
                  <button class="hover-up outline-none rounded-full flex flex-row justify-center
            items-center h-8 w-8   bg-brand-light">
                    <font-awesome-icon class="text-white  text-xl" :icon="['fal', 'plus']">
                    </font-awesome-icon>
                  </button>
                  <div class="text-xs text-additional-text font-bold ml-4">Добавить заведение</div>
                </div>
              </div>
            </div>
            <div class="flex flex-col justify-start items-start pt-4 width text-menuOrder-dark-blue">


            </div>
        </div>
    </div>
</template>

<script>

import Form from 'form-backend-validation';
import client from '@/clients/partners';
import formatDate from 'date-fns/format';
import Selectbox from '../../../selectbox.vue';
import SelectDate from '../../../select-date.vue';
import TrashBin from './layout/trash-bin';
import DeleteModal from '../delete-modal';

export default {
  name: 'step2',
  components: {
    DeleteModal,
    TrashBin,
    SelectDate,
    Selectbox,
  },
  props: ['dates', 'eventUuid', 'showHeader', 'isEdited'],
  data() {
    return {
      places: {},
      delete_modal: false,
      delete_date_index: '',
      delete_place_index: '',
      changingGamesStore: new Form({
        dates: null,
      }, {
        http: client,
      }),
    };
  },

  created() {
    client.get('/places/list')
      .then(({ data: { data: places } }) => {
        this.places = places;

        this.$emit('setPlaces', places);
      });
    this.changingGamesStore.populate({ dates: this.dates });
    if (this.changingGamesStore.dates[0].places.length === 0) {
      console.log(this.changingGamesStore.dates[0].places.length);
      this.changingGamesStore.dates[0].places.push('');
    }
  },

  methods: {
    formatDate,

    addPlace(dayIndex) {
      if (this.isEdited) {
        this.changingGamesStore.dates[dayIndex].places.push({
          ordered: false,
          place_id: '',
          uuid: '',
        });
      } else this.changingGamesStore.dates[dayIndex].places.push(null);
    },

    onTrashClick() {
      const elem = this.$refs.tra;
      this.delete_modal = true;
      this.delete_modal_index = currIndex;
    },

    onDeletePlace(dateIdx, placeIdx) {
      this.delete_modal = true;
      this.delete_place_index = placeIdx;
      this.delete_date_index = dateIdx;
    },

    async validate() {
      const savedData = this.changingGamesStore.data();
      await this.changingGamesStore.post(`/events/${this.eventUuid}/validate/step2`);
      this.changingGamesStore.populate(savedData);
      this.$emit('changedGamesStore', savedData);
    },
    delete_place() {
      this.changingGamesStore.dates[this.delete_date_index].places.splice(this.delete_place_index, 1);
      this.delete_modal = false;
    },
    getPlacesCount(dateIndex) {
      return this.changingGamesStore.dates[dateIndex].places.length;
    },

    hasTeams(date, place) {
      console.log(`date -${date} place -${place}`);
      return this.changingGamesStore.dates[date].places[place] ? this.changingGamesStore.dates[date].places[place].ordered === true : false;
    },
  },
};
</script>

<style scoped>
    .width {
        width: 45% !important;
    }

    .selectbox-width {
        width: 16rem !important;
    }
    @media (max-width:840px) {
      .trash-icon {
        transform: scale(1.3)
      }
    }
    @media (min-width: 1200px) and (max-width: 1700px) {
        .width {
            width: 65% !important;
        }
    }
</style>
